<mat-toolbar color="primary" class="d-flex">
  <div class="float-left"><img src="./assets/img/logo_logalty_white.png" alt="Logalty" id="logo"></div>
  <div class="ml-auto">
    <form>
      <span class='cobranding'>{{'NAVBAR.COBRANDING' | translate}}</span>
      <mat-form-field class="mx-3">
        <mat-select [(ngModel)]="selectedLang" name="lang" (selectionChange)="translate.use(selectedLang)">
          <mat-option *ngFor="let lang of translate.getLangs()" [value]="lang">{{lang | uppercase}}</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</mat-toolbar>